import { __extends } from "tslib";
import { ErrorBase } from '@awayjs/core';
var AnimationSetError = /** @class */ (function (_super) {
    __extends(AnimationSetError, _super);
    function AnimationSetError(message) {
        return _super.call(this, message) || this;
    }
    return AnimationSetError;
}(ErrorBase));
export { AnimationSetError };
